import React, { useCallback } from "react";
import DateRangePickerWrapper from "./DateRangePickerWrapper";
import RegionSelector from "./RegionSelector";

export default function SearchForm(props: SearchFormProps) {

    const { setInputStoreName } = props;

    const updateStoreText = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setInputStoreName(e.target.value);
    }, [setInputStoreName]);

    return <div className='row justify-content-center g-3'>
        <div className="col-12 col-sm-10">
            <div className="row g-3">
                <div className="col">
                    <div className="form-floating">
                        <RegionSelector inputArea={props.inputArea} setInputArea={props.setInputArea} />
                        <label htmlFor="region">地域／都道府県</label>
                    </div>
                </div>
                <div className="col">
                    <div className="form-floating">
                        <input type="text" className="form-control" name="store-query" value={props.inputStoreName} onChange={updateStoreText} />
                        <label htmlFor="store-query">店舗名</label>
                    </div>
                </div>
                <div className="col-12 col-lg">
                    <div className="form-floating">
                        <DateRangePickerWrapper startDateValue={props.inputStartDate} endDateValue={props.inputEndDate} onSetDate={props.setDateRange} />
                        <label htmlFor="date">開催日(範囲)</label>
                    </div>
                </div>
            </div>
        </div>
        <div className="col-3 col-sm-2 d-flex align-items-center">
            <button type="button" className="btn btn-primary rounded-pill w-100" disabled={props.isLoading} onClick={props.onSearchClicked}>
                検索
            </button>
        </div>
    </div>
};

interface SearchFormProps {
    inputArea: string;
    inputStoreName: string;
    inputStartDate: string;
    inputEndDate: string;

    setInputArea: (value: string) => any;
    setInputStoreName: (value: string) => any;
    setDateRange: (startDate: string, endDate: string) => any;

    onSearchClicked: () => any;
    isLoading: boolean;
}